import { Stack, SimpleGrid, Title } from "@mantine/core";
import RatePlanCard from "./RatePlanCard";

const RatePlanGrid = ({ ratePlans, handleEdit, handleDelete }) => {

  if (ratePlans.length === 0) {
    return (
      <Stack align="center" mt="xl">
        <Title order={4} c="dimmed">
          Aucun tarif créé
        </Title>
      </Stack>
    );
  }

  return (

    <Stack gap="lg" mt="md">

      

      {/* Grid */}

      <SimpleGrid
        cols={{ base: 1, sm: 2, md: 3, lg: 4 }}
        spacing="lg"
      >

        {ratePlans.map((plan) => (

          <RatePlanCard
            key={plan._id}
            plan={plan}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />

        ))}

      </SimpleGrid>

    </Stack>

  );
};

export default RatePlanGrid;